// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"6edd476d","244":"87dc1e16","409":"4d0be4f5","542":"dbc3d303","596":"4d9c2a70"}[chunkId] + ".chunk.css";
};